import React, { useState, useEffect } from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { supabase } from './lib/supabase'
import Login from './pages/Login'
import AthleteDashboard from './pages/AthleteDashboard'
import AdminDashboard from './pages/AdminDashboard'

export default function App() {
  const [session, setSession] = useState(null)
  const [profile, setProfile] = useState(null)
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    supabase.auth.getSession().then(({ data: { session } }) => {
      setSession(session)
      if (session) fetchProfile(session.user.id)
      else setLoading(false)
    })

    const { data: { subscription } } = supabase.auth.onAuthStateChange((_event, session) => {
      setSession(session)
      if (session) fetchProfile(session.user.id)
      else { setProfile(null); setLoading(false) }
    })

    return () => subscription.unsubscribe()
  }, [])

  async function fetchProfile(userId) {
    const { data } = await supabase.from('profiles').select('*').eq('id', userId).single()
    setProfile(data)
    setLoading(false)
  }

  if (loading) return <LoadingScreen />

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/login" element={!session ? <Login /> : <Navigate to="/" />} />
        <Route path="/admin/*" element={
          session && profile?.role === 'admin'
            ? <AdminDashboard profile={profile} />
            : <Navigate to="/" />
        } />
        <Route path="/*" element={
          session
            ? profile?.role === 'admin'
              ? <Navigate to="/admin" />
              : <AthleteDashboard profile={profile} session={session} />
            : <Navigate to="/login" />
        } />
      </Routes>
    </BrowserRouter>
  )
}

function LoadingScreen() {
  return (
    <div style={{
      height: '100vh', display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', background: 'var(--black)', gap: 20
    }}>
      <div style={{ fontFamily: 'var(--font-display)', fontSize: 32, letterSpacing: 3, color: 'var(--white)' }}>
        THE <span style={{ color: 'var(--gold)' }}>PLAYER</span> OFFICE
      </div>
      <div style={{ width: 40, height: 40, border: '3px solid var(--border)', borderTopColor: 'var(--gold)', borderRadius: '50%' }} className="spin" />
    </div>
  )
}
